import { applyTheme } from "./slide-themes";

// Raw slide data - just content, no styling
const esgSlidesData = [
  {
    id: "esg-overview",
    image: "/images/esg.jpg",
    imageAlt: "ESG/Sustainability reporting overview",
    imagePosition: "left",
    kicker: "ESG/Sustainability Reporting",
    title: "ESG",
    sections: [
      {
        description: [
          "Create data-backed ESG and sustainability reports with clear workflows.",
          "Align with GRI, ISSB and CSRD while keeping stakeholders in sync.",
          "Coordinate evidence, approvals and publication from a single workspace.",
        ],
      },
    ],
  },
  {
    id: "2_materiality_and_metrics",
    image: "/images/esg.jpg",
    imageAlt: "Materiality and metrics",
    imagePosition: "right",
    title: "Materiality and metrics",
    sections: [
      {
        description: [
          "Prioritise topics using double materiality and stakeholder inputs.",
          "Track KPIs, policies and targets across E, S and G pillars.",
          "Centralise evidence and approvals for every disclosure line item.",
        ],
      },
    ],
  },
  {
    id: "3_workflows_and_governance",
    image: "/images/esg.jpg",
    imageAlt: "Workflow and governance",
    imagePosition: "left",
    title: "Workflows and governance",
    sections: [
      {
        description: [
          "Assign responsibilities, due dates and review cycles with audit trails.",
          "Manage risks, policies and controls with clear ownership.",
          "Keep finance, compliance and sustainability teams aligned in one flow.",
        ],
      },
    ],
  },
  {
    id: "4_publication_and_assurance",
    image: "/images/esg.jpg",
    imageAlt: "Publication and assurance",
    imagePosition: "left",
    title: "Publication and assurance",
    sections: [
      {
        description: [
          "Generate branded ESG and sustainability reports for boards and regulators.",
          "Export disclosures and datasets for external assurance partners.",
          "Maintain transparency with traceable assumptions and versioned evidence.",
        ],
      },
    ],
  },
];

// Apply themes to slides
export const esgSlides = esgSlidesData.map((slide, index) => {
  const theme =
    index % 3 === 0 ? "default" : index % 3 === 1 ? "emerald" : "sky";
  return applyTheme(slide, theme, "green");
});
